<template>
  <div class="border-b-grey-300 rpt25 rpb75">
    <div class="flex items-center justify-start">
      <div class="flex items-center rpl25">
        <inputCheckbox 
          class="rmr50"
          title="Select All"
          :value="checkedAll" 
          @input="checkAll" 
        />
      </div>
      <h2 class="flex items-center rmb0">
        <span class="font-semibold text-base rmr50">Projects:</span>
        <span v-if="pagination.totalCount" class="text-xs muted">{{ pagination.totalCount }} projects total</span>
        <span class="text-xs rmx50">|</span>
        <span class="text-xs muted">{{ projectsLength }} projects loaded</span>
      </h2>
    </div>
  </div>
</template>

<script>
import inputCheckbox from '../../form-components/input-checkbox.vue';

export default {
  props: {
    projectsLength: Number,
    pagination: Object,
    checkedAll: Boolean
  },
  methods: {
    checkAll(e) {
      this.$emit('checkAll', e)
    }
  },
  components: {
    inputCheckbox,
  },
}
</script>

<style lang="scss" scoped>
.border-b-grey-300 {
  border-bottom: 1px solid #CBD5E0;
}
</style>